import Alert from './alert';
import Car from './car';
import $ from 'jquery';


import { showLoading, hideLoading } from './utils';

var Bid = {
  details : null,
  element : null,
  form    : null,
  id      : null,
  request : null,

  init: function(e) {
    e.preventDefault();
    var url = $(this).attr('href');

    Bid.details  = $('#car');
    Bid.element  = $('#bid');
    Bid.id       = url.split('=')[1];

    showLoading();
    Bid.element.load(url, function() {
      hideLoading();

      Bid.form     = $('#bid-form');
      Bid.cancel   = $('#cancel-bid');

      Bid.bindEvents();
      Bid.showForm();
    });
  },

  showForm: function() {
    this.details.hide();
    this.element.show();
  },

  hideForm: function(e) {
    if(typeof e !== 'undefined') e.preventDefault();

    Bid.details.show();
    Bid.element.html('');
  },

  bindEvents: function() {
    Bid.form.on('submit', Bid.submitForm);
    Bid.cancel.on('click', Bid.hideForm);
  },

  submitForm: function(e) {
    e.preventDefault();

    if(Bid.request !== null) {
      Bid.request.abort();
    }

    Bid.request = $.post(Bid.form.attr('action'), Bid.form.serialize(), function(response) {
      var alertLevel = 'danger';

      if(response.code === 200) {
        Bid.hideForm();
        Car.updateStatus({ id: Bid.id, status: 'has-bid' });
        alertLevel = 'success';

        $('#show-bid')
          .off('click')
          .removeClass('orange-btn')
          .addClass('blue-btn')
          .html('Go To Bids')
          .attr('href', '/bids');
      }

      if(typeof response.message !== 'undefined') {
        Alert.show({ level: alertLevel, message: response.message });
      }
    });
  }
}

export default Bid;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/bid.js